/**
 * The name of the built-in default retention policy. The default policy
 * cannot be renamed or deleted, and applies to every project that has no
 * explicitly assigned policy.
 */
export const DEFAULT_RETENTION_POLICY_NAME = "Default";
